
const getGiftCardSettings = (request) => {
    return new Promise((res, rej) => {
        axios.get('/giftcard/settings', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const updateGiftCardSettings = (request) => {
    return new Promise((res, rej) => {
        axios.post('/giftcard/settings', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const updateUserPermissions = (request) => {
    return new Promise((res, rej) => {
        axios.post('/giftcard/user-permissions', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const giftCardPurchase = (request) => {
    return new Promise((res, rej) => {
        axios.post('/merchant/giftcard/purchase', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const bulkUpdateUserPermissions = (request) => {
    return new Promise((res, rej) => {
        axios.post('/giftcard/bulk-user-permissions', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const getGiftCardSettlementReport = (request) => {
    return new Promise((res, rej) => {
        axios.post('/merchant/giftcard/settlement-report', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

export default {
    getGiftCardSettings,
    updateGiftCardSettings,
    updateUserPermissions,
    bulkUpdateUserPermissions,
    giftCardPurchase,
    getGiftCardSettlementReport
};
